/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2023-11-21 14:03:44
 * @LastEditors: Junteng Shi
 * @LastEditTime: 2025-03-28 10:25:19
 */
//按钮权限
import router from '@/router';

export default function (app: any) {
  app.directive('permission', {
    mounted(el, binding) {
      const type = binding.value || '';

      const permissionBtns = <string[]>router.currentRoute.value.meta.permission || [];

      const status = permissionBtns.some((item) => item == type);

      if (!status) {
        el.style.display = 'none';
      }
    },
  });
}
